import { Theme } from '@mui/material';
import { adjustFontSize, adjustLineHeight } from '@theme/styleOverrides/typography';

const floatingLabel = {
  '.MuiFormLabel-root.MuiInputLabel-root': {
    color: ({ palette }: Theme) => palette.text.subdued,
    fontSize: ({ palette }: Theme) => `${adjustFontSize(14, palette.fontSize)}px`,
    lineHeight: ({ palette }: Theme) => `${adjustLineHeight(20, palette.fontSize)}px`,
    transform: 'translateX(12px) translateY(10px)',
    padding: '4px 0 0',

    '&.MuiFormLabel-filled, &.Mui-focused': {
      color: ({ palette }: Theme) => palette.text.subdued,
      transform: 'translateX(16px) translateY(-10px) scale(.9)',
      transformOrigin: 'left',
      padding: '0',
    },

    '& ~ .MuiInputBase-root.MuiOutlinedInput-root .MuiInputBase-input.MuiOutlinedInput-input': {
      color: ({ palette }: Theme) => palette.text.main,
      paddingTop: '6px',
    },
  },
} as const;

const info = ({ palette }: Theme) =>
  ({
    '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
      padding: '2px 5px 0',
      backgroundColor: palette.info.main,
    },
  }) as const;

const warning = {
  '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
    padding: '2px 5px 0',
    backgroundColor: ({ palette }: Theme) => palette.warning.main,
  },
} as const;

const incident = {
  '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
    padding: '2px 5px 0',
    backgroundColor: ({ palette }: Theme) => palette.error.main,
  },
} as const;

const promotion = {
  '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
    padding: '2px 5px 0',
    backgroundColor: ({ palette }: Theme) => palette.success.main,
  },
} as const;

const buttonExtraRightPadding = {
  '& .MuiDialogActions-root': {
    padding: '0 10px 4px 0',
  },
} as const;

export { buttonExtraRightPadding, floatingLabel, incident, info, promotion, warning };
